import { createContext, useContext } from 'react';

interface WorkflowCallbacks {
  onRenameStep: (oldId: string, newId: string) => void;
  onAddNodeAfter: (sourceNodeId: string, actionId: string) => void;
}

export const WorkflowCallbacksContext = createContext<WorkflowCallbacks>({
  onRenameStep: () => {},
  onAddNodeAfter: () => {},
});

export const useWorkflowCallbacks = () => useContext(WorkflowCallbacksContext);
